export const dividerTokens = {
  divider: {
    root: {
      borderColor: '{surface.300}'
    }
  }
};

export type DividerTokens = typeof dividerTokens;
